import { css } from "@emotion/react";
import { ExitToApp, ExpandMore } from "@material-ui/icons";
import { ThemedCssCreator } from "src/config/emotion";
import styled from "../../../config/emotion";
import { StyledCompProps } from "../../../globalTypes/theme";

export const LogoutSectionContainer = styled.div`
  border-radius: 10px;
  box-shadow: 2px 2px 3px #e7e8ec, -2px -2px 3px #e7e8ec;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
`;

export const SectionRow = styled.div<StyledCompProps>`
  width: 100%;
  position: relative;
  height: auto;
  padding: 0.5em 1em;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  text-align: left;
  align-items: center;
  color: ${({ theme }) => theme.colors.secondaryColor};

  &:last-child {
    border-bottom: none;
  }
`;

export const SectionFooterContainer = styled.div<StyledCompProps>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px;
  font-weight: bold;
  box-shadow: 0 -1px 1px ${({ theme }) => theme.colors.primaryColor};
  color: ${({ theme }) => theme.colors.secondaryColor};

  &:hover {
    color: ${({ theme }) => theme.colors.primaryColor};
  }
`;

export const ExpandIcon = styled(ExpandMore, {
  shouldForwardProp: (prop) => prop !== "toggled",
})<{ toggled: boolean }>`
  color: ${({ theme }) => theme.colors.secondaryColor};
  cursor: pointer;
  ${({ toggled }) => {
    if (toggled) {
      return "transform: rotate(180deg);";
    }
    return null;
  }}

  &:hover {
    color: ${({ theme }) => theme.colors.primaryColor};
  }
`;

export const UserSectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

export const UserName = styled.span`
  font-size: 1.5em;
`;

export const UserLogin = styled.span<StyledCompProps>`
  color: ${({ theme }) => theme.colors.primaryColor};
  font-weight: bold;
`;

export const LanguageSectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  span {
    margin-right: 1em;
  }
`;

export const SectionLink = styled.button<StyledCompProps>`
  color: ${({ theme }) => theme.colors.secondaryColor};
  border: none;
  background-color: inherit;
  cursor: pointer;
  margin: 3px 0;
  text-align: left;
  padding: 0;

  &:hover {
    color: ${({ theme }) => theme.colors.primaryColor};
  }
`;

export const ExitIcon = styled(ExitToApp)`
  margin-left: 5px;
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const buttonContainerCss = css`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  & > * {
    margin-top: 10px;
  }
`;

export const impersonatedUserSectionCss: ThemedCssCreator = ({ colors }) => css`
  color: ${colors.delete};
`;
